import axios from 'axios'
import { HTTP } from 'types'
import { APIURL, config, getCurrentWorkspace } from './_utils'
import { createJsonData } from 'helpers/generalHelpers'

// #region SHARE ACCESS
const workspace = getCurrentWorkspace()

export const share = {
  form: (formSlug, formObj) =>
    axios.post(
      `${APIURL}/v4/forms/${formSlug}/share/`,
      createJsonData(formObj),
      config({ contentType: HTTP.ContentTypes.JSON, workspace })
    ),
  getAllUsers: (formSlug, params = {}) =>
    axios.get(
      `${APIURL}/v4/forms/${formSlug}/shared-users/`,
      config({ params, workspace })
    ),
  deleteUser: (userSlug) =>
    axios.delete(
      `${APIURL}/v4/form-shares/${userSlug}/`,
      config({
        workspace,
      })
    ),
  getAccessTypes: () =>
    axios.get(
      `${APIURL}/v2/forms/access-type-descriptions/?pagination=0`,
      config()
    ),
}

// #endregion SHARE ACCESS
